import { useState } from "react";
import {
  getClient,
  createClient,
  getClientById,
  updateClient,
  deleteClient,
} from "../../../Services/clientService";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../constants";

export const useClient = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({ search: null });

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchAllClients = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getClient({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.CLIENT_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.CLIENT_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchClientById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getClientById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.CLIENT_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.CLIENT_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const newClient = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await createClient(payload);
      if (response.status === 201) {
        data = response.data;
        const msg = TOAST_MESSAGES.CLIENT_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.CLIENT_CREATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.CLIENT_CREATE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateClientDetails = async (VendorId, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await updateClient(VendorId, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = TOAST_MESSAGES.UPDATE_CLIENT_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.UPDATE_CLIENT_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_CLIENT_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const removeClient = async (id) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteClient(id);
      if (response.status === 204 || response.status === 200) {
        toast.success(TOAST_MESSAGES.DELETE_CLIENT_SUCCESS);
        success = true;
      } else {
        toast.error(
          extractErrorMessage(response) || TOAST_MESSAGES.DELETE_CLIENT_FAILED
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.DELETE_CLIENT_ERROR
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  return {
    loading,
    page,
    totalPages,
    rowsPerPage,
    filters,
    setFilters,
    onPageChange,
    onPageSizeChange,
    fetchAllClients,
    fetchClientById,
    newClient,
    updateClientDetails,
    removeClient,
  };
};
